<template>
  <div>
    <div class="ibox animated fadeInRightBig">
      <div class="ibox-title">
        <h3>
          {{ (operation == "post" ? "Nova" : "Editar") + " " + modelName }}
          <i :class="'fa ' + icon" style="float: right; font-size: 21px; margin-top: -5px"></i>
        </h3>
      </div>
      <form id="form">
        <div class="ibox-content">
          <div class="row">
            <div class="form-group col-md-6">
              <label for="name"><span class="required">*</span> Nome da Categoria</label>
              <input type="text" class="form-control" name="description" v-model="model.description" id="name" />
            </div>
            <div class="form-group col-md-6">
              <label for="color"><span class="required">*</span>Cor</label> <br>
              <input type="color" value="#000000" id="style2" name="color" v-model="model.color"  />
             
        
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="pull-right">
            <router-link :to="backUrl" class="btn btn-info">
              <i class="fa fa-arrow-left"></i> Voltar
            </router-link>
            <a class="btn btn-success" @click="save">
              Salvar <i class="fa fa-save"></i>
            </a>
          </div>
          <p><span class="required">*</span> Campos Obrigatórios</p>
          <div class="clearfix"></div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      model: {
        description: "",
        color:"",
      },
      errors: undefined,
    };
  },
  props: {
    modelName: String,
    saveUrl: String,
    operation: String,
    id: String,
    backUrl: String,
    icon: String,
  },
  methods: {
    save: function () {
      const self = this;
      const api = self.$store.state.api + self.saveUrl + self.id;

      self.$http[self.operation](api, self.model)
        .then((response) => {
          self.$message(
            "Sucesso",
            `${self.modelName} ${self.operation == "post" ? "cadastrada" : "atualizada"
            } com sucesso!`,
            "success"
          );

          this.$router.push(self.backUrl);
        })
        .catch((error) => {
          self.errors = error.response.data;

          if (typeof self.errors === "object") {
            let html = "<ul>";

            $.each(self.errors, function (key, value) {
              html += "<li>" + value[0] + "</li>";
            });

            html += "</ul>";

            self.errors = html;
          }

          self.$message(null, self.errors, "error");
        });
    },
    getModel() {
      const self = this;
      const api = self.$store.state.api + self.saveUrl + self.id;

      self.$http
        .get(api)
        .then((response) => {
          self.model = response.data.data[0];
        })
        .catch((error) => {
          self.$message(
            null,
            "Ocorreu um erro ao buscar as informações",
            "error"
          );
        });
    },
  },
  mounted() {
    if (this.id) {
      this.getModel();
    }
  },
};
</script>

<style scoped>
#style2 {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  width: 50px;
  height: 50px;
  border: none;
  cursor: pointer;
}

#style2::-webkit-color-swatch {
  border-radius: 50%;
  border: 2px solid #000000;
}

#style2::-moz-color-swatch {
  border-radius: 50%;
  border: 7px solid #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/ChecklistCategory/FormSave.vue